import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Modal prompting sign up / login to continue (guest preview).
 */
const SignUpToContinueModal = ({
  open,
  onClose,
  researchInterests,
}) => {
  const navigate = useNavigate();

  if (!open) return null;

  const statePayload = {
    researchInterests: researchInterests || "",
    fromGuestPreview: true,
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="guest-signup-title"
    >
      <div className="max-w-md w-full rounded-lg bg-white p-6 shadow-xl text-center">
        <h2 id="guest-signup-title" className="text-xl font-semibold text-gray-900">
          Sign up for an account to continue
        </h2>
        <p className="mt-2 text-gray-600">
          Create a free account to save professors, get more recommendations, and unlock search.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-gray-300 px-5 py-2 font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => navigate("/login", { state: statePayload })}
            className="rounded-full border border-[#0196BF] px-5 py-2 font-medium text-[#0196BF] hover:bg-[#E0F7FF]"
          >
            Log in
          </button>
          <button
            type="button"
            onClick={() => navigate("/register", { state: statePayload })}
            className="rounded-full bg-[#0196BF] px-5 py-2 font-medium text-white hover:bg-[#017BA3]"
          >
            Sign up free
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpToContinueModal;
